import React from 'react';
import { shallowEqual } from 'react-redux';
import { Box, Label, Select } from '@apia/theme';
import { useResponsiveTableContext } from '../ResponsiveTableContext';
import { TResponsiveTableSortValue } from '../types';
import { useResponsiveTable } from '../store';

const NoMemoSort = ({ tableName }: { tableName?: string }) => {
  const { name, onSortChange } = useResponsiveTableContext(tableName);

  const columns = useResponsiveTable((global) => {
    return global.responsiveTableSlice[name]?.columns;
  }, shallowEqual);

  return (
    <>
      {columns?.map((column, columnIndex) => {
        return column.showAsAdditional ||
          column.allowSorting === false ? null : (
          <Label key={column.name}>
            <Box as="span">{column.label ?? column.name}</Box>
            <Box>
              <Select
                value={
                  column.currentSorting === null ? '' : column.currentSorting
                }
                onChange={(ev) => {
                  if (onSortChange)
                    onSortChange({
                      columnIndex,
                      column,
                      name: column.name,
                      sortValue:
                        ev.target.value === ''
                          ? null
                          : (ev.target.value as TResponsiveTableSortValue),
                    });
                }}
              >
                <option value="" />
                <option value="A">{window.ORDER_ASC_LABEL}</option>
                <option value="D">{window.ORDER_DESC_LABEL}</option>
              </Select>
            </Box>
          </Label>
        );
      })}
    </>
  );
};

export const Sort = React.memo(NoMemoSort);
